import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/home/home.vue'),
    meta : {'title': '首页','index':'1',hasBar:true,keepAlive: true}
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/list/list.vue'),
    meta : {'title': '分类','index':'1',hasBar:true,keepAlive: true}
  },
  {
    path: '/cart',
    name: 'cart',
    component: () => import('../views/cart/cart2.vue'),
    meta : {'title': '购物车','index':'1',hasBar:true}
  },
  {
    path: '/cart2',
    name: 'cart2',
    component: () => import('../views/cart/cart.vue'),
    meta : {'title': '购物车测试','index':'1',hasBar:true}
  },
  {
    path: '/cartDetail2',
    name: 'cartDetail2',
    component: () => import('../views/cart/cartDetail2.vue'),
    meta : {'title': '提交订单测试','index':'2',hasBar:false}
  },
  {
    path: '/cartDetail',
    name: 'cartDetail',
    component: () => import('../views/cart/cartDetail.vue'),
    meta : {'title': '提交订单','index':'2',hasBar:false}
  },
  
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/my/my.vue'),
    meta : {'title': '我的','index':'1',hasBar:true,keepAlive: true}
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product/product.vue'),
    meta: {'title': '产品页','index':'2',hasBar:false}
  },
  {
    path: '/address',
    name: 'address',
    component: () => import('../views/address/address.vue'),
    meta: {'title': '地址列表','index':'3',hasBar:false}
  },
  {
    path: '/mapApi',
    name: 'mapApi',
    component: () => import('../views/address/mapApi.vue'),
    meta: {'title': '地图选点','index':'4',hasBar:false}
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('../views/order/order.vue'),
    meta: {'title': '订单详情','index':'3',hasBar:false}
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: () => import('../views/order/orderList.vue'),
    meta: {'title': '订单列表','index':'2',hasBar:false}
  },
  {
    path: '/collection',
    name: 'collection',
    component: () => import('../views/collection/collection.vue'),
    meta: {'title': '我的收藏','index':'2',hasBar:false}
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('../views/search/search.vue'),
    meta: {'title': '搜索页','index':'2',hasBar:false}
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../views/error/error.vue'),
    meta: {'title': '错误','index':'4',hasBar:false,noAuth: true}
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
